<template>
    <page>
        <module enable-flex>
            <view-list ref="view" class="flex-grow" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadStats">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="维修人">
                            <c-select name="repair_user_id" async @search="searchUser"></c-select>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-select name="settle_state" :options="PURCHASE_SETTLE_STATE"></c-select>
                        </m-search-item>
                        <m-search-item label="维修时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>

                    <!-- 维修账单汇总统计 -->
                    <div class="stats-bar flex">
                        <div class="stats-card card-blue">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">维修总数</span>
                                    <span class="stats-value">{{ formatNumber(stats.repair_total_count) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon"><i class="tf tf-repair"></i></div>
                        </div>
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">维修总金额</span>
                                    <span class="stats-value">￥{{ formatMoney(stats.total_repair_amount) }}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>待结算：</label>￥{{ formatMoney(stats.pending_amount) }}</span>
                                    <ins>|</ins>
                                    <span><label>已结算：</label>￥{{ formatMoney(stats.settled_amount) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                        <div class="stats-card card-red">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">人工费总金额</span>
                                    <span class="stats-value">￥{{ formatMoney(stats.labor_amount) }}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>待结算：</label>￥{{ formatMoney(stats.labor_pending_amount) }}</span>
                                    <ins>|</ins>
                                    <span><label>已结算：</label>￥{{ formatMoney(stats.labor_settled_amount) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                    </div>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_repair_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!-- 维修产品（等级标签+产品信息） -->
                <template #produce_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

                <!-- 背贴码 -->
                <template #produce_unique_code="{data}">
                    {{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <!-- IMEI -->
                <template #produce_imei="{data}">
                    {{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <!-- 维修金额 -->
                <template #repair_amount="{data}">
                    <span v-if="data.repair_amount" style="color: green">￥{{ formatMoney(data.repair_amount) }}</span>
                    <span v-else>-</span>
                </template>

                <!-- 人工费（维修金额中 repair_item_code=1 的人工费明细合计） -->
                <template #labor_amount="{data}">
                    <span v-if="data.labor_amount" style="color: green">￥{{ formatMoney(data.labor_amount) }}</span>
                    <span v-else>-</span>
                </template>

                <!-- 结算状态 -->
                <template #settle_state="{data}">
                    <c-state async tag dict="PURCHASE_SETTLE_STATE" :value="data.settle_state"></c-state>
                </template>

                <!-- 维修人 -->
                <template #repair_user_realname="{data}">
                    {{data.repair_user_realname || '-'}}
                </template>

                <!-- 维修项目 -->
                <template #repair_item_name="{data}">
                    {{data.repair_item_name || '-'}}
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
    components: {},

    data() {
        return {
            workType: 120,
            stats: {}
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),

        ...asyncMapState(['PURCHASE_SETTLE_STATE'])
    },

    methods: {
        /************搜索用户（维修人）*******************************/
        searchUser(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SYSUSER',
                    user_type:1,            //仅查询【员工】
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /**
         * 加载维修账单汇总统计（随列表查询条件联动）
         */
        loadStats(listData, searchParams) {
            this.request({
                url: '/financial/repair/bill/summary',
                data: searchParams || {},
                success: data => {
                    this.stats = data || {};
                }
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },

        /**
         * 金额格式化（元，保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },

        /**
         * 数量格式化
         */
        formatNumber(val) {
            if (val === undefined || val === null || val === '') {
                return '0';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0' : String(Math.round(num));
        }
    }
}
</script>

<style lang="stylus" scoped>
    .stats-bar {
        flex-shrink: 0;
        gap: 10px;
        border-top: 1px solid #F5F5F5;
        padding: 8px 12px;

        .stats-card {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            max-width: 360px;
            min-height: 56px;
            padding: 8px 16px;
            border-radius: 6px;
            color: #fff;
            box-sizing: border-box;
            overflow: hidden;

            &.card-blue {
                background: linear-gradient(90deg, #2563eb, #3b82f6);
            }

            &.card-orange {
                background: linear-gradient(90deg, #f97316, #fb923c);
            }

            &.card-red {
                background: linear-gradient(90deg, #dc2626, #ef4444);
            }

            .stats-info {
                position: relative;
                z-index: 1;

                .stats-title-row {
                    display: flex;
                    align-items: baseline;
                    line-height: 24px;

                    .stats-label {
                        font-size: 12px;
                        opacity: 0.95;
                    }

                    .stats-value {
                        margin-left: 6px;
                        font-size: 18px;
                        font-weight: bold;
                    }
                }

                .stats-summary-row {
                    gap: .5em;
                    margin-top: 2px;
                    font-size: 11px;

                    ins {
                        text-decoration: none;
                        opacity: 0.6;
                    }

                    label {
                        opacity: 0.9;
                    }
                }
            }

            .stats-icon {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 32px;
                line-height: 1;
                opacity: 0.15;

                .tf {
                    font-size: 32px;
                }
            }
        }
    }
</style>
